import { NavLink } from "react-router-dom";

import { cn } from "@/lib/utils";

interface NavTab {
  label: string;
  href: string;
}

interface NavTabsProps {
  label: string;
  tabs: NavTab[];
  className?: string;
}

export function NavTabs({ label, tabs, className }: NavTabsProps) {
  return (
    <div className={cn("border-b", className)}>
      <nav aria-label={label} className="-ml-2">
        <ul className="-mb-px flex items-center">
          {tabs.map((tab) => (
            <li key={tab.href}>
              <NavLink
                to={tab.href}
                end
                className={({ isActive }) =>
                  cn(
                    "relative isolate flex h-11 items-center px-2 text-sm font-medium transition-colors md:h-10 md:text-[13px]",
                    "before:absolute before:inset-x-0 before:top-1/2 before:-z-10 before:h-8 before:-translate-y-1/2 before:rounded-md before:transition-colors hover:before:bg-accent md:before:h-7",
                    "after:absolute after:inset-x-2 after:bottom-0 after:h-0.5 after:rounded-full",
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
                    isActive
                      ? "text-foreground after:bg-foreground"
                      : "text-muted-foreground hover:text-foreground"
                  )
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
